import { render, staticRenderFns } from "./RideCertificate.vue?vue&type=template&id=b7995474&scoped=true&"
import script from "./RideCertificate.vue?vue&type=script&lang=js&"
export * from "./RideCertificate.vue?vue&type=script&lang=js&"
import style0 from "./RideCertificate.vue?vue&type=style&index=0&id=b7995474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7995474",
  null
  
)

export default component.exports